// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codman-comparison-picker__edit {
  height: var(--spacing5);
  line-height: var(--spacing5);
  border-radius: 4px;
  display: inline-flex;
  vertical-align: middle;
  margin-left: var(--spacing1);
  cursor: pointer;
  border: 1px solid transparent;
  position: relative;
}
.codman-comparison-picker__edit .codman-comparison-picker__edit__icon .lg-icon {
  height: var(--spacing4);
  width: var(--spacing4);
  margin: 2px;
}
.codman-comparison-picker__edit .codman-comparison-picker__edit__text {
  margin-right: var(--spacing1);
}
.codman-comparison-picker__edit:hover {
  border-color: rgb(var(--gray-color-40));
}`, "",{"version":3,"sources":["webpack://./libs/shared/feature-comparison-picker/src/lib/comparison-picker-edit/comparison-picker-button-edit/comparison-picker-button-edit.component.scss"],"names":[],"mappings":"AAEA;EACI,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAIQ;EACI,uBAAA;EACA,sBAAA;EACA,WAAA;AAFZ;AAMI;EACI,6BAAA;AAJR;AAOI;EACI,uCAAA;AALR","sourcesContent":["@use \"definitions\" as *;\n\n.codman-comparison-picker__edit {\n    height: var(--spacing5);\n    line-height: var(--spacing5);\n    border-radius: 4px;\n    display: inline-flex;\n    vertical-align: middle;\n    margin-left: var(--spacing1);\n    cursor: pointer;\n    border: 1px solid transparent;\n    position: relative;\n\n    .codman-comparison-picker__edit__icon {\n        .lg-icon {\n            height: var(--spacing4);\n            width: var(--spacing4);\n            margin: 2px;\n        }\n    }\n\n    .codman-comparison-picker__edit__text {\n        margin-right: var(--spacing1);\n    }\n\n    &:hover {\n        border-color: lg-color(--gray-color-40);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
